import React, { Component } from "react";

class WeightTextField extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    const { text, question, name, position, i, onTyping, placeholder } =
      this.props;

    const isValidInput = (input) => {
      /* 
        Allows empty string *("")
        Only allows 3 characters
        Only allows numeric values
      */

      if (input.length === 0) {
        return true;
      }
      if (input.length > 3) {
        return false;
      }
      const regex = /^[0-9]+$/gim;
      if (regex.test(input)) return true;
      return false;
    };

    const handleInputRestriction = (e) => {
      const input = e.target.value;

      //Validate the imput
      if (!isValidInput(input)) {
        return;
      }

      onTyping({
        questionIndex: position,
        index: i,
        value: input,
        field: text,
      });
    };

    return (
      <div
        style={{
          display: "flex",
          alignItems: "center",
          border: "1px solid #079EDA",
          borderRadius: 20,
          marginTop: 10,
        }}
      >
        <div
          style={{
            width: "80%",
            marginTop: 4,
            marginLeft: 10,
            textAlign: "left",
          }}
        >
          <p style={{ marginBottom: 0 }}>{placeholder}</p>
          <textarea
            name={text + name + position + i}
            id={text + name + position + i}
            rows={question.rows1 ? question.rows1 : "2"}
            value={text === "text1" ? question.text1 : question.text2}
            style={{
              border: 0,
              margin: 0,
              padding: 0,
              fontWeight: "bold",
              fontSize: "16px",
              height: "35px",
            }}
            onChange={(e) => handleInputRestriction(e)}
            className="required textarea-modal"
          ></textarea>
        </div>
        <div
          style={{
            justifyContent: "center",
            width: "20%",
          }}
        >
          <h1 style={{ fontWeight: "bold", color: "black", margin: 0 }}>lbs</h1>
        </div>
      </div>
    );
  }
}
export default WeightTextField;
